<template>
  <div class="report-yk-container">
    <div class="right-content">
      <!-- 顶部搜索栏 -->
      <div class="search-header">
        <div class="search-left">
          <!-- 药品类型下拉菜单 -->
          <el-select
            v-model="drugType"
            placeholder="药品类型"
            size="mini"
            style="width: 120px; margin-right: 10px;"
            @change="handleDrugTypeChange"
            clearable
          >
            <el-option label="西药" :value="1"></el-option>
            <el-option label="中药" :value="2"></el-option>
            <el-option label="卫材" :value="3"></el-option>
          </el-select>

          <!-- 日期范围选择器 -->
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="handleDateChange"
            size="mini"
            class="date-range-picker"
          >
          </el-date-picker>
          
          <el-input
            v-model="searchKeyword"
            placeholder="请输入药品名称或批号"
            class="search-input"
            clearable
            size="mini"
          >
            <el-button slot="append" icon="el-icon-Ssearch" @click="handleSearch">搜索</el-button>
          </el-input>
        </div>
        <div class="search-right">
          <el-button size="mini" type="primary" icon="el-icon-refresh" @click="refreshData">刷新</el-button>
          <el-button size="mini" type="primary" icon="el-icon-download" @click="exportData">导出</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        @selection-change="handleSelectionChange"
        :height="tableHeight"
      >
        <el-table-column prop="id" label="系统序号" width="80" fixed="left" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <!-- 新增：类型列 -->
        <el-table-column label="类型" width="80" align="center" fixed="left">
          <template slot-scope="scope">
            <el-tag :type="getTypeTagType(scope.row.drugType)" size="mini">
              {{ getTypeLabel(scope.row.drugType) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="drugName" label="药品名称" width="140" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.drugName }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="drugCode" label="药品编码" width="140" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.drugCode }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="drugSpec" label="药品规格" width="160" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.drugSpec }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="unt" label="计量单位" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.unt }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="purcPric" label="成本单价" width="100" align="center">
          <template slot-scope="scope">
            <span class="price-value">¥{{ scope.row.purcPric }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="salePric" label="销售单价" width="100" align="center">
          <template slot-scope="scope">
            <span class="leave-active">¥{{ scope.row.salePric }}</span>
          </template>
        </el-table-column>

        <!-- 库存期初 -->
        <el-table-column label="库存期初" align="center">
          <el-table-column prop="startCnt" label="期初数量" width="100" align="center"></el-table-column>
          <el-table-column prop="startPurcAmt" label="期初成本" width="100" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.startPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startSaleAmt" label="期初零售" width="100" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.startSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 库存期末 -->
        <el-table-column label="库存期末" align="center">
          <el-table-column prop="endCnt" label="期末数量" width="100" align="center"></el-table-column>
          <el-table-column prop="endPurcAmt" label="期末成本" width="100" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.endPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endSaleAmt" label="期末零售" width="100" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.endSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 本期入库 -->
        <el-table-column label="本期入库" align="center">
          <el-table-column prop="intoCnt" label="入库数量" width="100" align="center">
            <template slot-scope="scope">
              <span class="number-highlight">{{ scope.row.intoCnt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="intoPurcAmt" label="入库成本" width="100" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.intoPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="intoSaleAmt" label="入库零售" width="100" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.intoSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 本期出库 -->
        <el-table-column label="本期出库" align="center">
          <el-table-column prop="outCnt" label="出库数量" width="100" align="center"></el-table-column>
          <el-table-column prop="outPurcAmt" label="出库成本" width="100" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.outPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="outSaleAmt" label="出库零售" width="100" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.outSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 本期调拨入库 -->
        <el-table-column label="本期调拨入库" align="center">
          <el-table-column prop="allotIntoCnt" label="调拨入库数量" width="140" align="center"></el-table-column>
          <el-table-column prop="allotIntoPurcAmt" label="调拨入库成本" width="140" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.allotIntoPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="allotIntoSaleAmt" label="调拨入库零售" width="140" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.allotIntoSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 本期调拨出库 -->
        <el-table-column label="本期调拨出库" align="center">
          <el-table-column prop="allotOutCnt" label="调拨出库数量" width="140" align="center"></el-table-column>
          <el-table-column prop="allotOutPurcAmt" label="调拨出库成本" width="140" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.allotOutPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="allotOutSaleAmt" label="调拨出库零售" width="140" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.allotOutSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 盘盈盘亏 -->
        <el-table-column label="盘盈盘亏" align="center">
          <el-table-column prop="stockLossCnt" label="盘亏数量" width="100" align="center">
            <template slot-scope="scope">
              <span class="number-highlight">{{ scope.row.stockLossCnt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockLossPurcAmt" label="盘亏成本" width="100" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.stockLossPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockLossSaleAmt" label="盘亏零售" width="100" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.stockLossSaleAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockProfitCnt" label="盘盈数量" width="100" align="center">
            <template slot-scope="scope">
              <span class="number-highlight">{{ scope.row.stockProfitCnt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockProfitPurcAmt" label="盘盈成本" width="100" align="center">
            <template slot-scope="scope">
              <span class="price-value">¥{{ scope.row.stockProfitPurcAmt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stockProfitSaleAmt" label="盘盈零售" width="100" align="center">
            <template slot-scope="scope">
              <span class="leave-active">¥{{ scope.row.stockProfitSaleAmt }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column prop="manuLotnum" label="生产批号" width="140" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.manuLotnum }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="prodentpName" label="生产厂家" width="180" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.prodentpName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" icon="el-icon-Ssearch" @click="handleView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { dugReport } from "@/api/PSI/report.js";

export default {
  name: 'ReportCont',
  props: {
    // 接收父组件传递的报表类型：1-药库，2-药房
    reportType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      drugType: null, // 1-西药 2-中药 3-卫材
      dateRange: [],
      pickerOptions: {
        shortcuts: [
          { text: '最近一周', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', [start, end]); } },
          { text: '最近一个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', [start, end]); } },
          { text: '最近三个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 90); picker.$emit('pick', [start, end]); } }
        ],
        disabledDate(time) { return time.getTime() > Date.now(); }
      },
      tableHeight: 500,
      searchKeyword: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      multipleSelection: []
    };
  },
  watch: {
    reportType: {
      immediate: true,
      handler() {
        this.currentPage = 1;
        this.fetchReportData();
      }
    }
  },
  mounted() {
    this.initDefaultDateRange();
    this.fetchReportData();
    this.calculateTableHeight();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 类型标签映射
    getTypeLabel(type) {
      const map = { 1: '西药', 2: '中药', 3: '卫材' };
      return map[type] || '未知';
    },
    getTypeTagType(type) {
      const map = { 1: 'success', 2: 'warning', 3: 'danger' };
      return map[type] || 'info';
    },

    handleDrugTypeChange(val) {
      this.currentPage = 1;
      this.fetchReportData();
    },

    initDefaultDateRange() {
      const today = new Date();
      const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      this.dateRange = [
        this.formatDate(firstDayOfLastMonth),
        this.formatDate(today)
      ];
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handleDateChange(value) {
      if (value && value.length === 2) {
        this.currentPage = 1;
        this.fetchReportData();
      }
    },

    async fetchReportData() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          drugName: this.searchKeyword,
          reportType: this.reportType
        };
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0];
          params.endDate = this.dateRange[1];
        }
        if (this.drugType !== null && this.drugType !== undefined && this.drugType !== '') {
          params.drugType = this.drugType;
        }

        const res = await dugReport(params);
        if (res.code === 200) {
          const responseData = res.data;
          this.tableData = responseData.content || responseData.list || responseData || [];
          this.total = responseData.totalSize || responseData.total || 0;
          this.$message.success('数据加载成功');
        } else {
          this.$message.error(res.message || '接口返回状态异常');
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取报表数据失败:', error);
        this.$message.error('数据加载失败，请检查网络连接');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 暴露给父组件调用的刷新方法
    refreshData() {
      this.currentPage = 1;
      this.fetchReportData();
    },

    handleSearch() {
      this.currentPage = 1;
      this.fetchReportData();
    },

    handleResize() {
      this.calculateTableHeight();
    },

    calculateTableHeight() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight;
        const searchHeaderHeight = 60;
        const paginationHeight = 60;
        const padding = 40;
        this.tableHeight = windowHeight - searchHeaderHeight - paginationHeight - padding - 60;
      });
    },

    exportData() {
      this.$message.success('数据导出功能开发中');
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleView(row) {
      this.$message.info(`查看药品: ${row.drugName}`);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchReportData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchReportData();
    }
  }
};
</script>

<style lang="less" scoped>
.report-yk-container {
  height: calc(86vh - 20px);
  background: #f5f7fa;
  box-sizing: border-box;
  overflow: hidden;
}

.right-content {
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: white;
  flex-shrink: 0;
  min-height: 60px;
  border-bottom: 1px solid #e6e8eb;
  
  .search-left {
    display: flex;
    align-items: center;
    gap: 12px;
    
    .date-range-picker {
      width: 240px;
    }
    
    .search-input {
      width: 280px;
    }
  }
  
  .search-right {
    .el-button {
      margin-left: 8px;
    }
  }
}

.el-table {
  flex: 1;
  overflow: auto;
}

.pagination-container {
  padding: 12px;
  text-align: right;
  flex-shrink: 0;
  border-top: 1px solid #e6e8eb;
}

.number-highlight {
  font-weight: 500;
  color: #3b3b3b;
}
.price-value {
  font-weight: 300;
  color: #67c23a;
}
.leave-active {
  color: #f56c6c;
  font-weight: 300;
}

/deep/ .el-table {
  .el-table__header-wrapper {
    th {
      background: #f5f7fa;
      color: #606266;
      font-weight: 600;
    }
  }
}

@media (max-width: 1200px) {
  .search-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    .search-left {
      width: 100%;
      justify-content: space-between;
    }
    .search-right {
      width: 100%;
      justify-content: flex-end;
    }
  }
}

@media (max-width: 768px) {
  .report-yk-container { padding: 10px; }
  .search-header .search-left {
    flex-direction: column;
    gap: 8px;
    .date-range-picker, .search-input { width: 100%; }
  }
}
</style>